import React, { useState } from "react";
import { useWallet } from "../context/walletContext";
import { sendFundByUser } from "../api/fundTransferApi";
import { formatAmount } from "../utils/formatAmount";
import { useNotify } from "../context/NotifyContext";

const AddFund = ({ open, close ,memberData }) => {


  const [transferAmount, setTransferAmount] = useState("");
  const [remarks, setRemarks] = useState("");
  const { walletAmt, refreshWalletCart } = useWallet();
  const [loading,setLoading] = useState(false)
  const { notify } = useNotify();

  if (!open) return null; 

  const handleSubmit =async (e) => {
    e.preventDefault();

    if (!walletAmt || !transferAmount || !remarks) {
      notify("Please fill all fields", "error");
      return;
    }


     if (walletAmt?.main?.balance < transferAmount) {
      notify("Transfer Amount shoud not be Greater Than Actual Amount", "error");
      return;
    }

      if (!memberData?._id) {
      notify("Member Not Found", "error");
      return;
    }

    setLoading(true)

 try {
     const payload = {
      toUserId:memberData?._id,
      amount:transferAmount,
      reason:remarks || "Fund Transer"
    }

    const result = await sendFundByUser(payload)

    if(result?.success){
      
      notify("Fund Transfer Successfull", "success")
      refreshWalletCart()
      close()
    }

    else{
      notify(result?.message || "Fund transfer failed", "error")
    }
 } catch (error) {
  notify("Server Error", "error")
 }

    finally {
      setLoading(false)

    }
  

  };


  

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-2"
      onClick={close}
    >
      <div
        className="ds-modal w-full max-w-md p-4 sm:p-5"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex justify-between items-center mb-3">
          <h2 className="text-lg font-semibold text-[var(--text-dark)]">
            Fund Transfer From Your Wallet
          </h2>
          <button
            type="button"
            onClick={close}
            className="text-[var(--text-muted)] hover:text-[var(--text-dark)] text-xl"
          >
            ×
          </button>
        </div>

        {/* Form */}
        <form className="space-y-3" onSubmit={handleSubmit}>
          <div>
            <label className="ds-label">
              Available Balance  
            </label>
            <input
              type="number"
              placeholder="0.33"
              disabled

              value={formatAmount(walletAmt?.main?.balance || 0)}
            
              className="ds-input text-sm bg-[var(--bg-app)] cursor-not-allowed"
            />
          </div>

          <div>
            <label className="ds-label">
              Enter Amount To Transfer <span className="text-[var(--error-color)]">*</span>
            </label>
        <input
  type="text"
  placeholder="Enter Amount To Transfer To Agent"
  value={transferAmount}
  onChange={(e) => {
    let value = e.target.value;

    // Allow only numbers
    if (!/^\d*\.?\d*$/.test(value)) return;

    // Max allowed balance
    const available = Number(walletAmt?.main?.balance || 0);

    // If value > available, lock it
    if (Number(value) > available) {
      value = available;
    }

    setTransferAmount(value);
  }}
  className="ds-input text-sm"
/>

          </div>

          <div>
            <label className="ds-label">
              Remarks <span className="text-[var(--error-color)]">*</span>
            </label>

            <input
              type="text"
              placeholder="Remarks"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              className="ds-input text-sm"
            />
          </div>

          <div className="ds-form-actions">
            <button
              type="submit"
              disabled={!transferAmount || Number(transferAmount) <= 0 || loading}
              className="ds-btn ds-btn-primary"
            >
              {loading ? "Sending..." : "Send"}
            </button>
            <button
              type="button"
              onClick={close}
              className="ds-btn ds-btn-secondary"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddFund;
